import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Recipe from './Recipe.vue';
import { useCntfContent } from '~/composables/useCntfContent';
import { useGetTranslations } from '~/composables/useGetTranslations';
import useLegacySeoMeta from '~/composables/useLegacySeoMeta';
import { useSegment } from '~/composables/_next/useSegment';
import { useTrpc } from '~/composables/_next/useTrpc';
import { fetchReviews, fetchAllAverageReviews } from '~/helpers/reviewsRating';
import { cacheControl } from '~/helpers/cacheControl';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { PageTypes } from '~/types/PageTypes';
import { TrackingPageCategory } from '~/types/TrackingPageCategory';
import { useLocalization } from '~/composables/_next/useLocalization';
export default defineComponent({
  components: {
    Recipe: Recipe
  },
  middleware: [cacheControl('public, s-maxage=7200, stale-while-revalidate=3600, stale-if-error=3600') // 2 hours cache and 1 hour stale
  ],
  tracking: {
    category: TrackingPageCategory.RDP
  },
  setup: function setup() {
    var _useTrpc = useTrpc(),
      client = _useTrpc.client;
    var route = useRoute();
    var _useNuxt2App = useNuxt2App(),
      error = _useNuxt2App.error;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useDynamicYield = useDynamicYield(true),
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext,
      setDynamicYieldContextSSR = _useDynamicYield.setDynamicYieldContextSSR;
    var _useRightPath = useRightPath(),
      getDomain = _useRightPath.getDomain;
    var _useCntfContent = useCntfContent('pageRecipe'),
      search = _useCntfContent.search,
      content = _useCntfContent.content;
    var _useCntfContent2 = useCntfContent('pageRecipeSeo'),
      searchSeo = _useCntfContent2.search;
    var _useCntfContent3 = useCntfContent('itemTile'),
      searchTile = _useCntfContent3.search,
      contentTile = _useCntfContent3.content;
    var _useCntfContent4 = useCntfContent('pageRecipeList'),
      searchRecipeList = _useCntfContent4.search,
      contentRecipeList = _useCntfContent4.content;
    var _useCntfContent5 = useCntfContent('pageGenericCategory'),
      searchCategory = _useCntfContent5.search,
      contentCategory = _useCntfContent5.content;
    var _useCntfContent6 = useCntfContent('blockAdviceList'),
      searchRelatedAdvices = _useCntfContent6.search,
      contentRelatedAdvices = _useCntfContent6.content;
    var _useCntfContent7 = useCntfContent('blockCategoryList'),
      searchCategoryTags = _useCntfContent7.search,
      contentCategoryTags = _useCntfContent7.content;
    var _useLegacySeoMeta = useLegacySeoMeta(),
      setMeta = _useLegacySeoMeta.setMeta,
      getMeta = _useLegacySeoMeta.getMeta;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var contentResource = useState('recipe-content', function () {
      return null;
    });
    var parentCategory = useState('recipe-parent-category', function () {
      return null;
    });
    var recipeListing = useState('recipe-listing', function () {
      return null;
    });
    var tabs = useState('recipe-tabs', function () {
      return null;
    });
    var ingredients = useState('recipe-ingredients', function () {
      return null;
    });
    var relatedAdvices = useState('recipe-related-advices', function () {
      return null;
    });
    var categoryTags = useState('recipe-category-tags', function () {
      return null;
    });
    var _useSlug = useSlug(),
      transformSlugsForSeo = _useSlug.transformSlugsForSeo;

    // TODO: Remove after Nuxt 3 migration
    onMounted(function () {
      var _useSegment = useSegment(),
        trackPage = _useSegment.trackPage;
      trackPage(TrackingPageCategory.RDP, PageTypes.RDP);
    });
    var recipeId = useState('recipe-id', function () {
      return null;
    });
    var reviews = useState('recipe-reviews', function () {
      return reactive([]);
    });
    var averageReviews = useState('recipe-average-reviews', function () {});
    var pagination = useState('recipe-pagination', function () {});
    var state = useState('recipe-state', function () {
      return {
        itemsPerPage: 5,
        totalItems: 4,
        currentPage: 1
      };
    });
    var averageRecipeReviews = computed(function () {
      var _averageReviews$value;
      return (_averageReviews$value = averageReviews.value) === null || _averageReviews$value === void 0 ? void 0 : _averageReviews$value[recipeId.value];
    });
    function updateCurrentPage(newPage) {
      state.value.currentPage = newPage;
    }
    var pageRecipeData = useState("recipe-page-".concat(route.params.slug), function () {});
    var _useLazyAsyncData = useLazyAsyncData('recipe-index', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _content$value, _content$value2, _content$value2$, _content$value0, _content$value0$, _content$value0$$sys, _contentTile$value, _contentTile$value$, _content$value1, _content$value1$, _contentRecipeList$va3, _contentRecipeList$va4, _contentCategory$valu, _contentCategory$valu2, _content$value10, _content$value10$, _content$value11, _content$value11$, _contentRelatedAdvice, _contentRelatedAdvice2, _contentCategoryTags$, _contentCategoryTags$2, _contentResource$valu, _contentResource$valu2, _contentResource$valu3, _contentResource$valu4, _contentResource$valu5, _contentResource$valu6, _content$value12, _content$value12$, _content$value12$$fie, _content$value12$$fie2;
        var _content$value3, _content$value3$, _content$value4, _content$value4$, _content$value5, _content$value5$, _content$value5$$fiel, _content$value5$$fiel2, _content$value6, _content$value6$, _content$value6$$fiel, _content$value6$$fiel2, _content$value7, _content$value7$, _content$value7$$fiel, _content$value7$$fiel2, _content$value8, _content$value8$, _content$value8$$fiel, _content$value8$$fiel2, _contentRecipeList$va, _contentRecipeList$va2, _content$value9, _content$value9$, _content$value9$$fiel, _content$value9$$fiel2, _content$value9$$fiel3, recipeTitle, seoFallback, socialMeta, seo;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all([client.contentful.getPageRecipe.query({
                slug: route.params.slug,
                locale: locale
              }).then(function (data) {
                pageRecipeData.value = data;
              }), search({
                'content_type': 'pageRecipe',
                'fields.slug': route.params.slug,
                // Nesting level has changed because of performance problems
                // (with level 3 response has a lot of unused data)
                'include': 2
              }, ['tabs', 'ingredients']), searchSeo({
                'content_type': 'pageRecipe',
                'fields.slug': route.params.slug,
                'locale': '*'
              })]);
            case 2:
              if (!((_content$value = content.value) !== null && _content$value !== void 0 && _content$value.length)) {
                error({
                  statusCode: 404
                });
              }
              if (!((_content$value2 = content.value) !== null && _content$value2 !== void 0 && (_content$value2$ = _content$value2[0]) !== null && _content$value2$ !== void 0 && _content$value2$.sys.id)) {
                _context.next = 6;
                break;
              }
              _context.next = 6;
              return Promise.all([searchTile({
                'content_type': 'itemTile',
                'fields.link.sys.id[match]': (_content$value3 = content.value) === null || _content$value3 === void 0 ? void 0 : (_content$value3$ = _content$value3[0]) === null || _content$value3$ === void 0 ? void 0 : _content$value3$.sys.id
              }), searchRecipeList({
                content_type: 'pageRecipeList',
                links_to_entry: (_content$value4 = content.value) === null || _content$value4 === void 0 ? void 0 : (_content$value4$ = _content$value4[0]) === null || _content$value4$ === void 0 ? void 0 : _content$value4$.sys.id
              }), (_content$value5 = content.value) !== null && _content$value5 !== void 0 && (_content$value5$ = _content$value5[0]) !== null && _content$value5$ !== void 0 && (_content$value5$$fiel = _content$value5$.fields) !== null && _content$value5$$fiel !== void 0 && (_content$value5$$fiel2 = _content$value5$$fiel.associatedAdvices) !== null && _content$value5$$fiel2 !== void 0 && _content$value5$$fiel2.sys.id ? searchRelatedAdvices({
                'content_type': 'blockAdviceList',
                'sys.id': (_content$value6 = content.value) === null || _content$value6 === void 0 ? void 0 : (_content$value6$ = _content$value6[0]) === null || _content$value6$ === void 0 ? void 0 : (_content$value6$$fiel = _content$value6$.fields) === null || _content$value6$$fiel === void 0 ? void 0 : (_content$value6$$fiel2 = _content$value6$$fiel.associatedAdvices) === null || _content$value6$$fiel2 === void 0 ? void 0 : _content$value6$$fiel2.sys.id,
                'include': 3
              }) : Promise.resolve(), (_content$value7 = content.value) !== null && _content$value7 !== void 0 && (_content$value7$ = _content$value7[0]) !== null && _content$value7$ !== void 0 && (_content$value7$$fiel = _content$value7$.fields) !== null && _content$value7$$fiel !== void 0 && (_content$value7$$fiel2 = _content$value7$$fiel.categoryTags) !== null && _content$value7$$fiel2 !== void 0 && _content$value7$$fiel2.id ? searchCategoryTags({
                'content_type': 'blockCategoryList',
                'sys.id': (_content$value8 = content.value) === null || _content$value8 === void 0 ? void 0 : (_content$value8$ = _content$value8[0]) === null || _content$value8$ === void 0 ? void 0 : (_content$value8$$fiel = _content$value8$.fields) === null || _content$value8$$fiel === void 0 ? void 0 : (_content$value8$$fiel2 = _content$value8$$fiel.categoryTags) === null || _content$value8$$fiel2 === void 0 ? void 0 : _content$value8$$fiel2.id,
                'include': 3
              }) : Promise.resolve(), !((_contentRecipeList$va = contentRecipeList.value) !== null && _contentRecipeList$va !== void 0 && (_contentRecipeList$va2 = _contentRecipeList$va[0]) !== null && _contentRecipeList$va2 !== void 0 && _contentRecipeList$va2.fields) ? searchRecipeList({
                'content_type': 'pageRecipeList',
                'fields.recipeTypeV2.sys.contentType.sys.id': 'contentRecipeType',
                'fields.recipeTypeV2.fields.id[match]': (_content$value9 = content.value) === null || _content$value9 === void 0 ? void 0 : (_content$value9$ = _content$value9[0]) === null || _content$value9$ === void 0 ? void 0 : (_content$value9$$fiel = _content$value9$.fields) === null || _content$value9$$fiel === void 0 ? void 0 : (_content$value9$$fiel2 = _content$value9$$fiel.recipeTypeV2) === null || _content$value9$$fiel2 === void 0 ? void 0 : (_content$value9$$fiel3 = _content$value9$$fiel2.fields) === null || _content$value9$$fiel3 === void 0 ? void 0 : _content$value9$$fiel3.id
              }) : Promise.resolve()]);
            case 6:
              recipeId.value = (_content$value0 = content.value) === null || _content$value0 === void 0 ? void 0 : (_content$value0$ = _content$value0[0]) === null || _content$value0$ === void 0 ? void 0 : (_content$value0$$sys = _content$value0$.sys) === null || _content$value0$$sys === void 0 ? void 0 : _content$value0$$sys.id;
              _context.next = 9;
              return Promise.all([searchCategory({
                content_type: 'pageGenericCategory',
                links_to_entry: (_contentTile$value = contentTile.value) === null || _contentTile$value === void 0 ? void 0 : (_contentTile$value$ = _contentTile$value[0]) === null || _contentTile$value$ === void 0 ? void 0 : _contentTile$value$.sys.id
              }), fetchReviews(locale, [recipeId.value], 5).then(function (data) {
                reviews.value = data;
              }), fetchAllAverageReviews(recipeId.value).then(function (data) {
                averageReviews.value = data;
              })]);
            case 9:
              contentResource.value = (_content$value1 = content.value) === null || _content$value1 === void 0 ? void 0 : (_content$value1$ = _content$value1[0]) === null || _content$value1$ === void 0 ? void 0 : _content$value1$.fields;
              recipeListing.value = (_contentRecipeList$va3 = contentRecipeList.value) === null || _contentRecipeList$va3 === void 0 ? void 0 : (_contentRecipeList$va4 = _contentRecipeList$va3[0]) === null || _contentRecipeList$va4 === void 0 ? void 0 : _contentRecipeList$va4.fields;
              parentCategory.value = (_contentCategory$valu = contentCategory.value) === null || _contentCategory$valu === void 0 ? void 0 : (_contentCategory$valu2 = _contentCategory$valu[0]) === null || _contentCategory$valu2 === void 0 ? void 0 : _contentCategory$valu2.fields;
              tabs.value = (_content$value10 = content.value) === null || _content$value10 === void 0 ? void 0 : (_content$value10$ = _content$value10[0]) === null || _content$value10$ === void 0 ? void 0 : _content$value10$.fields.tabs;
              ingredients.value = (_content$value11 = content.value) === null || _content$value11 === void 0 ? void 0 : (_content$value11$ = _content$value11[0]) === null || _content$value11$ === void 0 ? void 0 : _content$value11$.fields.ingredients.filter(function (ingredient) {
                return ingredient === null || ingredient === void 0 ? void 0 : ingredient.fields;
              });
              relatedAdvices.value = (_contentRelatedAdvice = contentRelatedAdvices.value) === null || _contentRelatedAdvice === void 0 ? void 0 : (_contentRelatedAdvice2 = _contentRelatedAdvice[0]) === null || _contentRelatedAdvice2 === void 0 ? void 0 : _contentRelatedAdvice2.fields;
              categoryTags.value = (_contentCategoryTags$ = contentCategoryTags.value) === null || _contentCategoryTags$ === void 0 ? void 0 : (_contentCategoryTags$2 = _contentCategoryTags$[0]) === null || _contentCategoryTags$2 === void 0 ? void 0 : _contentCategoryTags$2.fields.categoryTags;
              recipeTitle = (_contentResource$valu = contentResource.value) === null || _contentResource$valu === void 0 ? void 0 : _contentResource$valu.title;
              seoFallback = recipeTitle ? {
                title: recipeTitle,
                description: translate('seo.recipe.description').replace('{name}', recipeTitle)
              } : {};
              socialMeta = [{
                property: 'og:title',
                content: (_contentResource$valu2 = contentResource.value) === null || _contentResource$valu2 === void 0 ? void 0 : _contentResource$valu2.name
              }, {
                property: 'og:image',
                content: (_contentResource$valu3 = contentResource.value) === null || _contentResource$valu3 === void 0 ? void 0 : (_contentResource$valu4 = _contentResource$valu3.carousel) === null || _contentResource$valu4 === void 0 ? void 0 : (_contentResource$valu5 = _contentResource$valu4[0]) === null || _contentResource$valu5 === void 0 ? void 0 : _contentResource$valu5.fields.file.url
              }, {
                property: 'og:url',
                content: "".concat(getDomain()).concat(route.path)
              }, {
                property: 'twitter:card',
                content: 'summary_large_image'
              }, {
                property: 'twitter:title',
                content: (_contentResource$valu6 = contentResource.value) === null || _contentResource$valu6 === void 0 ? void 0 : _contentResource$valu6.name
              }, {
                property: 'og:type',
                content: 'article'
              }];
              seo = Object.assign({}, seoFallback, (_content$value12 = content.value) === null || _content$value12 === void 0 ? void 0 : (_content$value12$ = _content$value12[0]) === null || _content$value12$ === void 0 ? void 0 : (_content$value12$$fie = _content$value12$.fields) === null || _content$value12$$fie === void 0 ? void 0 : (_content$value12$$fie2 = _content$value12$$fie.seo) === null || _content$value12$$fie2 === void 0 ? void 0 : _content$value12$$fie2.fields, {
                socialMeta: socialMeta
              }, {
                slug: transformSlugsForSeo(pageRecipeData.value.data.pageRecipeCollection.items[0])
              });
              setMeta(seo);
              return _context.abrupt("return", true);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))),
      loading = _useLazyAsyncData.pending;
    onMounted(function () {
      setDynamicYieldContext('OTHER', ['Recipe_Page']);
    });
    setDynamicYieldContextSSR('OTHER', ['Recipe_Page']);
    return {
      pagination: pagination,
      averageRecipeReviews: averageRecipeReviews,
      recipeId: recipeId,
      state: state,
      updateCurrentPage: updateCurrentPage,
      reviews: reviews,
      getMeta: getMeta,
      contentResource: contentResource,
      tabs: tabs,
      ingredients: ingredients,
      parentCategory: parentCategory,
      recipeListing: recipeListing,
      relatedAdvices: relatedAdvices,
      categoryTags: categoryTags,
      loading: loading
    };
  }
});